import { CustomAutocomplete } from 'components/util/CustomAutocomplete';
import { FunctionComponent } from 'react';
import { SelectItem } from 'components/util/select/selectData';
import { TextField } from '@nps.today/component-library';

interface AccessScopeInputProps {
  options: SelectItem[];
  value: SelectItem[];
  label: string;
  helperText: string;
  dataTestId: string;
  loading: boolean;
  setValue: (value: SelectItem[]) => void;
}

export const AccessScopeInput: FunctionComponent<AccessScopeInputProps> = ({
  options,
  value,
  label,
  helperText,
  dataTestId,
  loading,
  setValue
}) => {
  const availableOptions = options.filter((o) => !value.some((v) => v.value === o.value));
  return (
    <CustomAutocomplete
      disabled={loading}
      dataTestId={dataTestId}
      multiple
      options={availableOptions}
      value={value}
      onChange={(_, value) => setValue(value)}
      getOptionLabel={(o) => o?.displayValue}
      getOptionKey={(o) => o.value}
      renderInput={(params) => (
        <TextField
          dataTestId={dataTestId}
          {...params}
          variant="outlined"
          label={label}
          helperText={helperText}
        />
      )}
    />
  );
};
